// Competitor positioning data — drives the /vs/:competitor pages and the
// prerendered static HTML used for "X alternative" SEO ranking.
//
// Every claim here is something we'll defend in the rich content body, NOT
// vague marketing language. Avoid superlatives that crawl-quality reviewers
// (BBB / Google manual review / users) can fact-check us on.

export const COMPETITORS = {
  '3commas': {
    slug: '3commas',
    name: '3Commas',
    tagline: 'Established CEX bot platform with grid + DCA + Smart Trade — focused on centralized exchanges, no native DEX trading.',
    homepage: 'https://3commas.io',
    founded: 2017,
    headline: 'haythix vs 3Commas — which crypto trading bot to pick in 2026',
    subheading: 'Migrating from 3Commas? Here is a verified side-by-side on what you keep, what you gain, and what you lose.',
    audience: 'Active CEX traders, copy traders, grid + DCA users',
    competitorStrengths: [
      'Long-established brand, 7+ years in market',
      'Strong CEX integrations (Binance, KuCoin, Coinbase, others)',
      'Mature Smart Trade with TPs / SL',
      'Marketplace of paid bot signals',
    ],
    competitorWeaknesses: [
      'No native DEX trading — CEX-only',
      'No on-chain wallet support / cross-chain arbitrage',
      'Subscription priced significantly higher at the top tier (~$60/mo Pro vs haythix $75.99 Pro covers MUCH more surface area)',
      'No built-in tokenomics tools (issuers locked out)',
      'No native algo orders (TWAP / VWAP / Iceberg / Bracket) — third-party only',
      'Community + paid channels are separate plans, not bundled',
    ],
    pricingComparison: [
      { feature: 'Entry price',                  haythix: '$10 / mo (Starter)',         them: '$22 / mo (Pro)' },
      { feature: 'Mid-tier',                     haythix: '$49.99 / mo (Trader)',       them: '$37 / mo (Expert)' },
      { feature: 'Top tier',                     haythix: '$149.99 / mo (Elite)',       them: '$66 / mo (Pro / no DEX)' },
      { feature: 'Pay in USDC?',                 haythix: 'Yes',                        them: 'No' },
      { feature: 'Free trial',                   haythix: '14 days, all features',      them: '7 days, limited' },
    ],
    headToHeadFeatures: [
      { feature: 'DEX trading (15 chains)',                          haythix: true,  them: false },
      { feature: 'CEX trading (15 exchanges)',                       haythix: true,  them: true  },
      { feature: 'Cross-chain arbitrage detector',                   haythix: true,  them: false },
      { feature: 'Real copy trading (auto-execution, not advisory)', haythix: true,  them: true  },
      { feature: 'Grid bot',                                         haythix: true,  them: true  },
      { feature: 'DCA bot with safety orders',                       haythix: true,  them: true  },
      { feature: 'Smart Trade (TPs / SL)',                           haythix: true,  them: true  },
      { feature: 'Conditional / regime-switching bot',               haythix: true,  them: false },
      { feature: 'Algo orders (TWAP / VWAP / Iceberg / Bracket)',    haythix: true,  them: false },
      { feature: 'TradingView webhook automation',                   haythix: true,  them: true  },
      { feature: 'AI signal generation (built-in)',                  haythix: true,  them: false },
      { feature: 'Token issuer tools (tokenomics, launch, listing)', haythix: true,  them: false },
      { feature: 'On-chain wallet profiler + token analyzer',        haythix: true,  them: false },
      { feature: 'Live community + paid channels',                   haythix: true,  them: false },
      { feature: 'Tax reports (FIFO / LIFO / HIFO)',                 haythix: true,  them: 'partial' },
      { feature: 'Pay subscription in USDC',                         haythix: true,  them: false },
    ],
    whySwitch: [
      'You traded only CEX so far and want to add DEX without learning a new tool. haythix unifies them with the same bot engines.',
      'You hit the Pro / DEX-features-not-included wall on 3Commas. haythix bundles DEX, CEX, algo orders, and AI signals in one price.',
      'You want issuer-side tools (tokenomics, launch roadmap, CEX listing readiness) on the same login as your trading. 3Commas does not offer these.',
      'You want to pay in USDC instead of card. 3Commas is card-only.',
    ],
    migration: [
      'Export your API keys from 3Commas → connect to haythix in Settings → Exchanges (same encryption pattern: never withdraw permission).',
      'Recreate active bots using the same templates you used on 3Commas — Grid Bot + DCA + Smart Trade have direct equivalents.',
      'Keep 3Commas running for one cycle if you want to A/B the platforms before fully cutting over.',
    ],
  },

  'cryptohopper': {
    slug: 'cryptohopper',
    name: 'Cryptohopper',
    tagline: 'Strategy designer + marketplace + signaler platform focused on CEX automation.',
    homepage: 'https://www.cryptohopper.com',
    founded: 2017,
    headline: 'haythix vs Cryptohopper — full feature + pricing comparison',
    subheading: 'Looking for a Cryptohopper alternative? Here is what haythix gives you that the Hopper does not.',
    audience: 'Strategy traders, signal followers, algo experimenters',
    competitorStrengths: [
      'Strategy designer with 130+ indicators',
      'Hopper marketplace for paid signals',
      'Established brand, multi-language support',
      'Decent backtesting tool',
    ],
    competitorWeaknesses: [
      'No native DEX trading',
      'No on-chain or cross-chain features',
      'No native tokenomics or issuer tools',
      'Pricing tiers gate critical features (Hero plan needed for many real strategies)',
      'No live community + paid creator channels',
      'Tax reports are basic',
    ],
    pricingComparison: [
      { feature: 'Entry price',           haythix: '$10 / mo (Starter)',        them: '$19.99 / mo (Explorer)' },
      { feature: 'Mid-tier',              haythix: '$49.99 / mo (Trader)',      them: '$49.99 / mo (Adventurer)' },
      { feature: 'Top tier',              haythix: '$149.99 / mo (Elite)',      them: '$129.99 / mo (Hero, CEX-only)' },
      { feature: 'Pay in USDC?',          haythix: 'Yes',                       them: 'No' },
      { feature: 'Free trial',            haythix: '14 days, all features',     them: '7 days, limited' },
    ],
    headToHeadFeatures: [
      { feature: 'DEX trading (15 chains)',                          haythix: true,  them: false },
      { feature: 'CEX trading',                                      haythix: true,  them: true  },
      { feature: 'Cross-chain arbitrage detector',                   haythix: true,  them: false },
      { feature: 'AI signal generation (built-in)',                  haythix: true,  them: 'partial' },
      { feature: 'Strategy designer with backtest',                  haythix: true,  them: true  },
      { feature: 'Real copy trading (auto-execution)',               haythix: true,  them: 'partial' },
      { feature: 'Algo orders (TWAP / VWAP / Iceberg / Bracket)',    haythix: true,  them: false },
      { feature: 'Conditional / regime-switching bot',               haythix: true,  them: false },
      { feature: 'Token issuer tools (tokenomics, launch, listing)', haythix: true,  them: false },
      { feature: 'On-chain wallet profiler + token analyzer',        haythix: true,  them: false },
      { feature: 'TradingView webhook automation',                   haythix: true,  them: true  },
      { feature: 'Live community + paid channels',                   haythix: true,  them: false },
      { feature: 'Pay subscription in USDC',                         haythix: true,  them: false },
    ],
    whySwitch: [
      'Hopper is CEX-only. haythix gives you DEX on 15 chains plus your CEX accounts with one login.',
      'You hit the Hero-only wall on advanced strategies. haythix bundles them in lower tiers.',
      'You want cross-chain arbitrage detection. Hopper does not detect inter-chain spreads.',
      'You want issuer-side tooling (you also build / advise on tokens). Hopper has none of this.',
    ],
    migration: [
      'Export Hopper strategies as JSON → recreate in haythix Strategy Builder (or use one of the 18 prebuilt templates).',
      'Move CEX API keys → connect to haythix in Settings → Exchanges.',
      'Activate the same paper-trading flow on haythix to validate the strategy before live cutover.',
    ],
  },

  'bitsgap': {
    slug: 'bitsgap',
    name: 'Bitsgap',
    tagline: 'Grid bot + arbitrage scanner + portfolio terminal for CEX traders.',
    homepage: 'https://bitsgap.com',
    founded: 2018,
    headline: 'haythix vs Bitsgap — grid bots, arbitrage, and what is actually different',
    subheading: 'Looking for a Bitsgap alternative? Here is the full breakdown on features, fees, and the DEX gap.',
    audience: 'Grid bot users, CEX arbitrage hunters',
    competitorStrengths: [
      'Strong CEX grid bot with backtest',
      'Built-in CEX-to-CEX arbitrage scanner',
      'Portfolio terminal across exchanges',
      'Clean trading UI',
    ],
    competitorWeaknesses: [
      'No DEX trading at all',
      'No cross-chain arbitrage — CEX-to-CEX only',
      'No copy trading',
      'No on-chain wallet profiler / token analyzer',
      'No issuer tools',
      'No live community or paid channels',
    ],
    pricingComparison: [
      { feature: 'Entry price',            haythix: '$10 / mo (Starter)',       them: '$24 / mo (Basic)' },
      { feature: 'Mid-tier',               haythix: '$49.99 / mo (Trader)',     them: '$49 / mo (Advanced)' },
      { feature: 'Top tier',               haythix: '$149.99 / mo (Elite)',     them: '$110 / mo (Pro, CEX-only)' },
      { feature: 'Pay in USDC?',           haythix: 'Yes',                      them: 'No' },
      { feature: 'Free trial',             haythix: '14 days, all features',    them: '7 days, limited' },
    ],
    headToHeadFeatures: [
      { feature: 'DEX trading (15 chains)',                          haythix: true,  them: false },
      { feature: 'CEX trading',                                      haythix: true,  them: true  },
      { feature: 'Cross-chain arbitrage detector',                   haythix: true,  them: false },
      { feature: 'CEX-to-CEX arbitrage scanner',                     haythix: true,  them: true  },
      { feature: 'Grid bot with backtest',                           haythix: true,  them: true  },
      { feature: 'Real copy trading',                                haythix: true,  them: false },
      { feature: 'AI signal generation',                             haythix: true,  them: false },
      { feature: 'Smart Trade (TPs / SL)',                           haythix: true,  them: true  },
      { feature: 'Algo orders (TWAP / VWAP / Iceberg / Bracket)',    haythix: true,  them: false },
      { feature: 'TradingView webhook automation',                   haythix: true,  them: true  },
      { feature: 'Token issuer tools',                               haythix: true,  them: false },
      { feature: 'On-chain wallet profiler + token analyzer',        haythix: true,  them: false },
      { feature: 'Live community + paid channels',                   haythix: true,  them: false },
      { feature: 'Pay subscription in USDC',                         haythix: true,  them: false },
    ],
    whySwitch: [
      'You like Bitsgap grid bots but want DEX too. haythix runs the same grid logic on Base, Polygon, Arbitrum, and 12 others — plus your CEX accounts.',
      'You hunt arbitrage but Bitsgap only sees CEX-to-CEX. haythix adds cross-chain DEX spreads (the highest-edge category right now).',
      'You want copy trading — Bitsgap does not offer it.',
    ],
    migration: [
      'Copy your grid configurations from Bitsgap → recreate in haythix Grid Bot setup (same parameters: lower / upper price, levels, capital).',
      'Move CEX API keys → haythix Settings → Exchanges.',
      'Once stable, expand the same grid strategy to DEX pairs (e.g., USDC/WETH on Base) which Bitsgap can not run.',
    ],
  },

  'pionex': {
    slug: 'pionex',
    name: 'Pionex',
    tagline: 'Free in-exchange trading bots — 16 built-in bots on Pionex CEX only.',
    homepage: 'https://www.pionex.com',
    founded: 2019,
    headline: 'haythix vs Pionex — the trade-off behind "free" bots',
    subheading: 'Pionex bots are free but lock you into their exchange. Here is the full picture on what that costs you.',
    audience: 'Beginner crypto traders, fee-sensitive users',
    competitorStrengths: [
      '16 built-in trading bots — no setup needed',
      'Zero subscription fee (revenue from spread + fees)',
      'Mobile-first UX',
      'Good for first-time bot users',
    ],
    competitorWeaknesses: [
      'Bots only run on Pionex exchange — your other CEX accounts are locked out',
      'No DEX trading at all',
      'No on-chain wallet support',
      'No copy trading',
      'No tokenomics or issuer tools',
      'Limited strategy customization — fixed bot templates only',
      'No backtest tool',
    ],
    pricingComparison: [
      { feature: 'Subscription',                  haythix: '$10-149.99 / mo',           them: 'Free (uses Pionex fees instead)' },
      { feature: 'Trading fees',                  haythix: 'Your exchange fees (your choice of 15)', them: 'Pionex spot fees (0.05% taker)' },
      { feature: 'Multi-exchange',                haythix: '15 CEX + 15 DEX chains',    them: 'Pionex only' },
      { feature: 'Pay in USDC?',                  haythix: 'Yes',                       them: 'N/A (no subscription)' },
      { feature: 'Free trial',                    haythix: '14 days, all features',     them: 'Always free' },
    ],
    headToHeadFeatures: [
      { feature: 'Use YOUR existing exchange accounts',              haythix: true,  them: false },
      { feature: 'DEX trading (15 chains)',                          haythix: true,  them: false },
      { feature: 'CEX trading (15 exchanges)',                       haythix: true,  them: 'partial' },
      { feature: 'Cross-chain arbitrage detector',                   haythix: true,  them: false },
      { feature: 'Custom strategies + backtest',                     haythix: true,  them: false },
      { feature: 'Real copy trading',                                haythix: true,  them: false },
      { feature: 'AI signal generation',                             haythix: true,  them: false },
      { feature: 'Algo orders (TWAP / VWAP / Iceberg / Bracket)',    haythix: true,  them: false },
      { feature: 'TradingView webhook automation',                   haythix: true,  them: false },
      { feature: 'Tokenomics + issuer tools',                        haythix: true,  them: false },
      { feature: 'Live community + paid channels',                   haythix: true,  them: false },
      { feature: 'Tax reports (FIFO / LIFO / HIFO)',                 haythix: true,  them: false },
    ],
    whySwitch: [
      'You hit the ceiling on Pionex built-in bots and want REAL strategy customization with backtest evidence.',
      'You already use Coinbase / Kraken / Binance and do not want to fund a Pionex account just for bots.',
      'You want DEX trading — Pionex has no on-chain support.',
      'You need pro features (algo orders, copy trading, AI signals) that Pionex does not offer at any tier.',
    ],
    migration: [
      'You do not need to close your Pionex account — just stop funding it. Move capital back to your primary exchange.',
      'Connect that exchange to haythix via API key (Settings → Exchanges).',
      'Recreate your favorite Pionex bot using haythix Smart Trade / Grid / DCA templates — same logic, your choice of exchange.',
    ],
  },

  'coinrule': {
    slug: 'coinrule',
    name: 'Coinrule',
    tagline: 'Rule-based "if-then" strategy builder for beginner crypto automation.',
    homepage: 'https://coinrule.com',
    founded: 2018,
    headline: 'haythix vs Coinrule — graduate from rule templates to real strategy',
    subheading: 'Coinrule is great for first steps. Once you outgrow the template ceiling, here is what haythix adds.',
    audience: 'Beginner traders, rule-template users',
    competitorStrengths: [
      'Clean "if X then Y" rule builder — easy onboarding',
      'Library of prebuilt rule templates',
      'Free tier available',
      'Beginner-friendly UI',
    ],
    competitorWeaknesses: [
      'No DEX trading',
      'Strategy logic limited to simple if-then chains — no indicators, no backtest at lower tiers',
      'No copy trading',
      'No AI signals',
      'No algo orders',
      'No tokenomics tools',
      'Top tier ($59 / mo) still no DEX + no advanced features',
    ],
    pricingComparison: [
      { feature: 'Free tier?',                    haythix: '14-day trial, all features', them: 'Yes, very limited (3 rules)' },
      { feature: 'Entry price',                   haythix: '$10 / mo (Starter)',          them: '$29.99 / mo (Hobbyist)' },
      { feature: 'Mid-tier',                      haythix: '$49.99 / mo (Trader)',        them: '$59.99 / mo (Trader)' },
      { feature: 'Top tier',                      haythix: '$149.99 / mo (Elite)',        them: '$449 / mo (Pro, CEX-only)' },
      { feature: 'Pay in USDC?',                  haythix: 'Yes',                         them: 'No' },
    ],
    headToHeadFeatures: [
      { feature: 'DEX trading (15 chains)',                          haythix: true,  them: false },
      { feature: 'CEX trading',                                      haythix: true,  them: true  },
      { feature: 'Full strategy builder + 18 templates',             haythix: true,  them: 'partial' },
      { feature: 'Real backtest engine',                             haythix: true,  them: 'partial' },
      { feature: 'Cross-chain arbitrage detector',                   haythix: true,  them: false },
      { feature: 'Grid bot / DCA / Smart Trade',                     haythix: true,  them: 'partial' },
      { feature: 'Real copy trading',                                haythix: true,  them: false },
      { feature: 'AI signal generation',                             haythix: true,  them: false },
      { feature: 'Algo orders (TWAP / VWAP / Iceberg / Bracket)',    haythix: true,  them: false },
      { feature: 'TradingView webhook automation',                   haythix: true,  them: true  },
      { feature: 'Token issuer tools',                               haythix: true,  them: false },
      { feature: 'Live community + paid channels',                   haythix: true,  them: false },
      { feature: 'Tax reports (FIFO / LIFO / HIFO)',                 haythix: true,  them: false },
    ],
    whySwitch: [
      'You hit the rule-template ceiling and need real indicators, backtest, and strategy composition.',
      'You want DEX — Coinrule has none.',
      'Coinrule top tier is $449 / mo and STILL no DEX. haythix Elite is $149.99 with the full DEX + CEX surface.',
      'You want copy trading or AI signals — Coinrule offers neither.',
    ],
    migration: [
      'Coinrule rules map directly to haythix Strategy Builder conditions — same if/then structure, more indicators.',
      'Connect your CEX API keys to haythix → recreate the rule with backtest evidence before going live.',
    ],
  },

  'dextools': {
    slug: 'dextools',
    name: 'DexTools',
    tagline: 'DEX analytics + token discovery dashboard — read-only, no execution.',
    homepage: 'https://www.dextools.io',
    founded: 2020,
    headline: 'haythix vs DexTools — from token discovery to actual execution',
    subheading: 'DexTools shows you what is happening. haythix lets you act on it with bots, copy trading, and full execution.',
    audience: 'DEX traders, token hunters, on-chain analytics users',
    competitorStrengths: [
      'Strong DEX pair analytics + charts',
      'Honest token discovery dashboard',
      'Hot pairs / trending lists',
      'Multi-chain coverage',
    ],
    competitorWeaknesses: [
      'Read-only — you cannot trade from DexTools, you have to leave the platform',
      'No bot automation (grid, DCA, conditional)',
      'No CEX support',
      'No copy trading',
      'No AI signals or strategy builder',
      'No tokenomics tools',
    ],
    pricingComparison: [
      { feature: 'Subscription',           haythix: '$10-149.99 / mo',          them: 'Free + Premium (≈$25 / mo)' },
      { feature: 'Execution',              haythix: 'Full DEX + CEX execution',  them: 'None — view only' },
      { feature: 'Multi-chain coverage',   haythix: '15 chains',                 them: '20+ chains (analytics only)' },
      { feature: 'Pay in USDC?',           haythix: 'Yes',                       them: 'No' },
    ],
    headToHeadFeatures: [
      { feature: 'Actual DEX trade execution',                       haythix: true,  them: false },
      { feature: 'CEX trade execution',                              haythix: true,  them: false },
      { feature: 'Token discovery + on-chain analytics',             haythix: true,  them: true  },
      { feature: 'Wallet profiler',                                  haythix: true,  them: 'partial' },
      { feature: 'Token launch scanner (rug-risk signals)',          haythix: true,  them: 'partial' },
      { feature: 'Bot automation (Grid, DCA, Smart Trade)',          haythix: true,  them: false },
      { feature: 'Cross-chain arbitrage detector',                   haythix: true,  them: false },
      { feature: 'Real copy trading',                                haythix: true,  them: false },
      { feature: 'AI signal generation',                             haythix: true,  them: false },
      { feature: 'Algo orders (TWAP / VWAP / Iceberg / Bracket)',    haythix: true,  them: false },
      { feature: 'Tokenomics + issuer tools',                        haythix: true,  them: false },
      { feature: 'Live community + paid channels',                   haythix: true,  them: false },
    ],
    whySwitch: [
      'You spot opportunities on DexTools but have to leave the platform to act. haythix combines analytics + execution in one login.',
      'You want bot automation on the DEX pairs DexTools surfaces. haythix runs grid / DCA / smart trade on those exact pools.',
      'You want copy trading on top traders — DexTools is analytics only.',
    ],
    migration: [
      'Keep using DexTools for discovery if you want — they are not mutually exclusive.',
      'Connect your wallet to haythix to enable execution on pairs you discover.',
      'Set up a Token Discovery bookmark workflow: DexTools spot → haythix bot config in 60 seconds.',
    ],
  },

  'dexscreener': {
    slug: 'dexscreener',
    name: 'DexScreener',
    tagline: 'DEX pair tracker + trending lists across 30+ chains — view-only.',
    homepage: 'https://dexscreener.com',
    founded: 2021,
    headline: 'haythix vs DexScreener — find pairs AND trade them in one tool',
    subheading: 'DexScreener tracks what is moving. haythix lets you actually execute, automate, and copy on top of it.',
    audience: 'DEX-first traders, memecoin hunters, multi-chain monitors',
    competitorStrengths: [
      'Wide chain coverage (30+ chains)',
      'Real-time pair tracking + trending',
      'Multi-chain dashboards',
      'Free + fast',
    ],
    competitorWeaknesses: [
      'View-only — no trade execution',
      'No bot automation',
      'No CEX support',
      'No copy trading',
      'No on-chain bot strategies (grid / DCA / smart trade on DEX)',
      'No issuer tools',
    ],
    pricingComparison: [
      { feature: 'Subscription',           haythix: '$10-149.99 / mo',           them: 'Free' },
      { feature: 'Execution',              haythix: 'Full DEX + CEX execution',   them: 'None' },
      { feature: 'Multi-chain coverage',   haythix: '15 chains, execution',       them: '30+ chains, analytics only' },
      { feature: 'Pay in USDC?',           haythix: 'Yes',                        them: 'N/A' },
    ],
    headToHeadFeatures: [
      { feature: 'Real-time DEX pair tracking',                      haythix: true,  them: true  },
      { feature: 'Actual DEX trade execution',                       haythix: true,  them: false },
      { feature: 'CEX trade execution',                              haythix: true,  them: false },
      { feature: 'Bot automation on DEX (Grid, DCA, Smart Trade)',   haythix: true,  them: false },
      { feature: 'Cross-chain arbitrage detector',                   haythix: true,  them: false },
      { feature: 'Token discovery + risk signals',                   haythix: true,  them: 'partial' },
      { feature: 'Wallet profiler',                                  haythix: true,  them: 'partial' },
      { feature: 'Real copy trading',                                haythix: true,  them: false },
      { feature: 'AI signal generation',                             haythix: true,  them: false },
      { feature: 'Algo orders',                                      haythix: true,  them: false },
      { feature: 'Tokenomics + issuer tools',                        haythix: true,  them: false },
    ],
    whySwitch: [
      'DexScreener shows you the pair. haythix lets you trade and automate it in the same UI.',
      'You want to RUN a strategy (grid / DCA / smart trade) on the DEX pair DexScreener flagged. haythix does this on Base, Polygon, Arbitrum, and 12 other chains.',
      'You want copy trading on top DEX traders — DexScreener has no execution layer.',
    ],
    migration: [
      'Keep DexScreener as your tracking dashboard — useful for fast discovery.',
      'When you spot something tradeable, jump to haythix → connect wallet → run a Smart Trade with TP / SL or a Grid bot on that pair.',
      'Use haythix Token Launch Scanner to verify rug-risk signals BEFORE committing capital.',
    ],
  },
};

export const COMPETITOR_SLUGS = Object.keys(COMPETITORS);
